


























































import { Component } from 'vue-property-decorator';

import Vue from 'vue';
import { Action, Getter } from 'vuex-class';
import { ActionTypes, GetterTypes } from '@/modules/neopvc/store/types';

import { Project, tabs } from '@/modules/neopvc/models';
import moment from 'moment';
import { MessageService } from '@/services/messageService';

@Component({})
export default class extends Vue {
  @Getter(GetterTypes.GET_PROJECTS)
  public projects: Project[];

  @Action(ActionTypes.FETCH_PROJECTS)
  public getProjectsAsync: () => Promise<void>;

  @Action(ActionTypes.UPDATE_CURRENT_TAB)
  public updateCurrentTab: (tab: string) => void;

  @Action(ActionTypes.UPDATE_NEW_PROJECT)
  public updateNewProject: (newProject: boolean) => void;

  @Action(ActionTypes.CALCULATE_PROJECT_DESTINY)
  public calculateProjectDestiny: (project: Project) => Promise<void>;

  @Action(ActionTypes.CALCULATE_PROJECT_ORIGIN)
  public calculateProjectOrigin: (project: Project) => Promise<void>;

  public isLoading = false;

  public moment = moment;

  public async created() {
    this.updateCurrentTab(tabs.list);
    this.updateNewProject(false);

    await this.getProjectsAsync();
  }

  public formatDate(value: string) {
    return moment(String(value)).format('MM/YYYY');
  }

  public async onCalculateDestiny(project: Project) {
    try {
      await this.calculateProjectDestiny(project);

      MessageService.Success(
         'Sucesso',
          'PVC -> Inicio do calculo da DESTINO',
        'center',
      );
    } catch (error) {
       MessageService.Error(
        'Error',
        'Operação não foi realizada! Contacte o suporte.',
        'center',
      );
    }
  }

  public async onCalculateOrigin(project: Project) {
    try {
      await this.calculateProjectOrigin(project);

      MessageService.Success(
          'Sucesso',
          'PVC -> Inicio do calculo da ORIGEM',
          'center',
      );
    } catch (error) {
      MessageService.Error(
          'Error',
          'Operação não foi realizada! Contacte o suporte.',
          'center',
      );
    }
  }

  public get projectHeader() {
    return [
      { text: 'Ações', value: 'id', sortable: false },
      { text: 'Código', value: 'id', sortable: false },
      {
        text: 'Nome',
        value: 'name',
        class: 'text-wrap',
        sortable: false,
      },
      {
        text: 'Data de Referência',
        value: 'dateReference',
        class: 'text-wrap',
        sortable: false,
      },
      {
        text: 'Distribuição Inicial',
        value: 'dateStartDistribution',
        class: 'text-wrap',
        sortable: false,
      },
      {
        text: 'Distribuição Final',
        value: 'dateEndDistribution',
        class: 'text-wrap',
        sortable: false,
      },
      {
        text: 'Bairro - Índice Original Share',
        value: 'indexNeighborhoodOriginalShare',
        class: 'text-wrap',
        sortable: false,
      },
      {
        text: 'Bairro - Índice Demográfico',
        value: 'indexNeighborhoodDemographicShare',
        class: 'text-wrap',
        width: '140px',
        sortable: false,
      },
      {
        text: 'Bairro - Índice Outlet Share',
        value: 'indexNeighborhoodOutletShare',
        class: 'text-wrap',
        width: '140px',
        sortable: false,
      },
      {
        text: 'Bairro - Índice Distancia Share',
        value: 'indexNeighborhoodDistanceShare',
        class: 'text-wrap',
        width: '140px',
        sortable: false,
      },
      {
        text: 'Setor - Índice Original Share',
        value: 'indexSectorOriginalShare',
        sortable: false,
        class: 'text-wrap',
      },
      {
        text: 'Setor - Índice Demográfico',
        value: 'indexSectorDemographicShare',
        sortable: false,
        class: 'text-wrap',
      },
      {
        text: 'Setor - Índice de Corte Original Share',
        value: 'cutoffOriginalData',
        sortable: false,
        class: 'text-wrap',
      },
    ];
  }

  public get noData() {
    return this.isLoading
      ? 'Buscando projetos...'
      : 'Nenhum projeto encontrado.';
  }
}
